var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid p-0"},[_c('navbar'),(this.$route.params && this.$route.params.slug)?_c('subnavbar'):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }